// @file Javascript for Profile page. Simple run-time Vue app.
import { currentUserPromise } from 'bits/current_user'
import { captureException, setScope } from 'bits/error_tracker'
import { setupVueApp } from 'bits/vue'
import { configureApiFetch } from 'surface/api_fetch'
import VueApollo from 'vue-apollo'
import ProfilePage from 'vuecomponents/ProfilePage.vue'
import { storeOptions } from 'vuexstore/profile'

configureApiFetch({ useArvo: false })
currentUserPromise.then((user) => setScope({ userId: user.id })).catch(captureException)

setupVueApp({
  el: '#app',
  usePinia: true,
  storeOptions,
  plugins: [VueApollo],
  rootComponent: ProfilePage,
  initializeStore(store) {
    store.dispatch('initializeState').catch(captureException)
  },
}).catch(captureException)
